module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-email",
    class: {
      guest: !_vm.loggedIn
    }
  }, [(_vm.loggedIn) ? _c('header', {
    staticClass: "mdl-layout__header mdl-color--grey-100 mdl-color-text--grey-600"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.state == 'loading') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n().loading.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.i18n().loading.text))])])]) : _vm._e(), _vm._v(" "), (_vm.state == 'used' || _vm.state == 'expired' || _vm.state == 'done' || _vm.state == 'notFound') ? _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title mdl-color--primary"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v(_vm._s(_vm.i18n()[_vm.state].title))])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text mdl-card--expand loading"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n()[_vm.state].text))])]), _vm._v(" "), (_vm.state == 'done') ? _c('div', {
    staticClass: "mdl-card__actions mdl-card--border",
    class: {
      blurred: _vm.state == 'working'
    }
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect",
    on: {
      "click": _vm.exit
    }
  }, [_vm._v("\n        " + _vm._s(_vm.i18n()[_vm.state].exitButton) + "\n      ")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-layout__header-row"
  }, [_c('span', [_vm._v("Confirm Email")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-116e178c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/emailPassword/ConfirmEmail.vue
// module id = 433
// module chunks = 0